import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  DispatchHead: {
    VocTyp: "",
    VocTypName: "",
    VocNo: 0,
    PostDate: new Date(),
    Party: "",
    PartyName: "",
    Loc: "",
    LocName: "",
    DocStatus: "",
    InstancePicking: "",
    BinCode: "",
    BinName: "",
    Status: "",
  },
  DispatchList: [
    {
      DocTypCode: "",
      DocTypName: "",
      Date: "",
      Status: "",
    },
  ],
  DispatchData: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: "",
    Scan: "",
  },
};

const SliceDispatch = createSlice({
  name: "Dispatch",
  initialState: { value: initialState },

  reducers: {
    DispatchHead_Set: (state, action) => {
      state.value.DispatchHead = action.payload;
    },
    DispatchHead_Status_Set: (state, action) => {
      state.value.DispatchHead.Status = action.payload.Status;
    },
    DispatchList_Set: (state, action) => {
      state.value.DispatchList = action.payload;
    },
    DispatchData_Set: (state, action) => {
      state.value.DispatchData = action.payload;
    },
    DispatchData_OnLoad_Set: (state, action) => {
      state.value.DispatchData = action.payload;
    },
    Dispatch_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  DispatchHead_Set,
  Dispatch_Init,
  DispatchList_Set,
  DispatchData_Set,
  DispatchHead_Status_Set,
  DispatchData_OnLoad_Set,
} = SliceDispatch.actions;
export default SliceDispatch.reducer;
